import React from 'react'
import { connect } from 'react-redux'
import { numberTropicalizer } from '@navent-jobs/config'
import Text from '@navent-jobs/ui-kit/components/text'
import { EmpleosTotalText, Total } from './mixins'

interface EmpleosTotalProps {
  h1?: string | null
  preh1?: string | null
  grandTotal: number
  totalAvisos: number
  loading: boolean
  cantidadEmpleos: boolean
}

const CantidadEmpleos = ({ totalAvisos, grandTotal, h1, preh1, loading, cantidadEmpleos }: EmpleosTotalProps) => {
  if (!cantidadEmpleos) {
    return null
  }

  return (
    <EmpleosTotalText>
      <Text size="sm" fontWeight="semibold" as="h1">
        {loading ? (
          'Buscando ofertas de empleo'
        ) : (
          <>
            {preh1 ? `${preh1} ` : undefined}
            <Total>{numberTropicalizer(grandTotal || totalAvisos)}</Total> {h1}
          </>
        )}
      </Text>
    </EmpleosTotalText>
  )
}

const states = ({ listadoAvisosStore }) => {
  const { totalAvisos, grandTotal, loading, cantidadEmpleos, seoWordings } = listadoAvisosStore
  const { h1, preh1 } = seoWordings
  return {
    totalAvisos,
    grandTotal,
    loading,
    cantidadEmpleos,
    h1,
    preh1,
  }
}

export default connect(states)(CantidadEmpleos)
